import moment from 'moment';
import { Tag } from 'antd';
import { connect } from 'react-redux';
import { config } from '../../constant';
import React, { Fragment, useState, useEffect, useRef } from 'react';
import cloneDeep from 'lodash.clonedeep';
import ReactEcharts from '../../Echarts/Echarts';
import { arrayOfObjects } from '../../../Mock/MockJson';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';
import {
  trendLabelTranslationPieNew,
  predictionsLegendsTranslation
} from '../../../Utils/Adapter/translationAdapter';

const Pie = (props) => {
  const [option, setOption] = useState(getOption());
  const [refreshDateTime, setRefreshDateTime] = useState(moment());

  let [errorInAPI, setErrorInAPI] = useState(false);
  let [noDataInDB, setNoDataInDB] = useState(false);
  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData();
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear,
    props.translationCache
  ]);

  const getData = async () => {
    requestCheck.current = false;
    errorInAPI = false;
    noDataInDB = false;
    let json = [];
    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = arrayOfObjects;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }

    if ((json && json.message) || (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)) {
      if (json.message) {
        errorInAPI = true;
      } else if (json.length === 0) {
        noDataInDB = true;
      }
    } else {
      if (json && Array.isArray(json)) {
        let newOption = cloneDeep(option);
        let legend = {
          left: 'center',
          textStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black',
            fontSize: 18,
            fontWeight: 'bold'
          },
          data: json.map((data) => data.Description)
        };

        let series = await trendLabelTranslationPieNew(json, props.translationCache);
        let legends = await predictionsLegendsTranslation(legend, props.translationCache);
        newOption.series[0].data = series;
        newOption.legend = legends;
        setOption(newOption);
        setRefreshDateTime(moment());
      }
    }
    setErrorInAPI(errorInAPI);
    setNoDataInDB(noDataInDB);
  };


  const renderContent = () => {
    if (noDataInDB) {
      return <NoRecordComponent />;
    }
    if (errorInAPI) {
      return <ErrorComponent />;
    }
    return (
      <ReactEcharts
        option={option}
        style={{ height: '90%', width: '100%' }}
        className="react_for_echarts"
      />
    );
  };

  return (
    <Fragment>
      {props.graphprops && props.graphprops.checked ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}
      {renderContent()}
    </Fragment>
  );

  function getOption() {
    let responseType =
      props &&
        props.graphprops &&
        props.graphprops[props.graphprops.graph] &&
        props.graphprops[props.graphprops.graph].ResponseType
        ? props.graphprops[props.graphprops.graph].ResponseType
        : '';

    return {
      title: {
        left: 'center'
      },
      tooltip: {
        trigger: 'item',
        formatter: responseType === 'Show Value' ? '{b} : {c}' : '{b} : {d}%'
      },
      label: {
        color: props.theme.algorithm === "dark" ? 'white' : 'black',
        fontWeight: 'bold',
        fontSize: 14
      },
      textStyle: {
        color: props.theme.algorithm === "dark" ? 'white' : 'black',
        fontWeight: 'bold',
        fontSize: 18
      },
      legend: {
        left: 'center',
        textStyle: {
          color: props.theme.algorithm === "dark" ? 'white' : 'black'
        },
        data: []
      },
      toolbox: {
        showTitle: false,
        orient: 'vertical',
        itemSize: 25,
        feature: {
          saveAsImage: {
            title: 'download',
            backgroundColor: 'black',
            name: props.graphprops.title,
            iconStyle: {
              borderColor: '#8c8c8c',
              borderWidth: 2
            }
          }
        }
      },
      series: [
        {
          type: 'pie',
          radius: '70%',
          avoidLabelOverlap: false,
          selectedMode: 'single',
          color: props.graphprops && props.graphprops.pie ? props.graphprops.pie.colors : [],
          label: {
            formatter: responseType === 'Show Value' ? '{b|{c}}' : '{per|{d}%',
            color: props.theme.algorithm === "dark" ? 'white' : 'black',
            backgroundColor: '#eee',
            borderColor: '#aaa',
            borderWidth: 1,
            borderRadius: 4,
            padding: [0, 4],
            rich: {
              b: {
                fontSize: 14,
                fontWeight: 'bold',
                color: props.theme.algorithm === "dark" ? 'white' : 'black',
                lineHeight: 22,
                backgroundColor: '#c23531',
                padding: [3, 5],
                borderRadius: 2
              },
              per: {
                fontSize: 14,
                fontWeight: 'bold',
                color: props.theme.algorithm === "dark" ? 'white' : 'black',
                backgroundColor: '#52c41a',
                padding: [3, 5],
                borderRadius: 2
              }
            }
          },
          data: [],
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    };
  }
};

const mapStateToProps = (state) => {
  return {
    theme: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone
  };
};
export default connect(mapStateToProps)(Pie);